const backToTop = () => {
  const topButton = document.getElementById('back-to-top');

  if (!topButton) {
    return;
  }

  function trackScroll() {
    if (window.pageYOffset > 100) {
      topButton.classList.add('is-visible');
    } else {
      topButton.classList.remove('is-visible');
    }
  }

  topButton.addEventListener('click', (event) => {
    event.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth',
    });
  });

  window.addEventListener('scroll', trackScroll, { passive: true });
  trackScroll();
};

export default backToTop;
